<template>
  <el-drawer
    title=""
    :visible.sync="showDrawer"
    :with-header="false"
    :append-to-body="true"
    :modal="false"
    :wrapperClosable="false"
  >
    <div class="addDrawerTitle">
      {{ drawerTitle }}
    </div>
    <el-form
      ref="resForm"
      :model="resForm"
      class="searchForm"
      :rules="formRules"
    >
      <el-form-item
        v-for="(item, index) in formData"
        :key="index + item.prop"
        :label="$t(item.label)"
        :required="item.required"
        :prop="item.prop"
        :class="item.prop == 'urlList' ? 'heightItem' : ''"
      >
        <!-- <el-radio-group 
         v-if="item.prop==='resIconType'"
         v-model="resForm[item.prop]">
            <el-radio :label="3">已选中项</el-radio>
            <el-radio :label="6">未选中项</el-radio>
        </el-radio-group> -->
        <el-button
          v-if="item.prop == 'urlList'"
          class="yesBtn"
          @click="addUrl()"
          >{{ $t(`common.add`) }}</el-button
        >
        <el-button
          v-if="item.prop == 'urlList'"
          class="noBtn"
          type="danger"
          @click="deleteUrl()"
          >{{ $t(`common.remove`) }}</el-button
        >
        <el-table
          v-if="item.prop == 'urlList'"
          :row-key="getRowKey"
          :data="resForm.urlList"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            :reserve-selection="true"
          />
          <el-table-column
            prop="name"
            :label="$t(`authorization.resource.urlName`)"
            width="250px"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.name"
                :placeholder="$t(`common.pleaseInput`)"
                clearable
                @blur="checkName(scope.row.name)"
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="value"
            label="URL"
            width="250px"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.value"
                :placeholder="$t(`common.pleaseInput`)"
                clearable
                @blur="checkValue(scope.row.name)"
              >
              </el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-input
          v-model="resForm[item.prop]"
          :placeholder="$t(item.placeholder)"
          clearable
          v-if="
            item.prop !== 'urlList' &&
            item.prop !== 'status' &&
            item.prop !== 'belongSys' &&
            item.prop !== 'resType'
          "
        >
        </el-input>
        <el-input
          v-model="resForm[item.prop]"
          :placeholder="$t(item.placeholder)"
          clearable
          v-if="item.prop == 'belongSys'"
        >
        </el-input>
        <el-select
          v-model="resForm[item.prop]"
          :placeholder="$t(item.placeholder)"
          clearable
          v-if="item.prop == 'resType'"
          :disabled="selectedItems == 0"
        >
          <el-option
            :label="$t(`authorization.resource.module`)"
            value="MODULE"
          ></el-option>
          <el-option
            :label="$t(`authorization.resource.group`)"
            value="GROUP"
          ></el-option>
          <el-option
            :label="$t(`authorization.resource.menu`)"
            value="VIEW"
          ></el-option>
          <el-option
            :label="$t(`authorization.resource.button`)"
            value="UNIT"
          ></el-option>
          <el-option
            :label="$t(`authorization.resource.dataAuth`)"
            value="DATAAUTH"
          ></el-option>
          <el-option
            :label="$t(`authorization.resource.urlAuth`)"
            value="URL"
          ></el-option>
        </el-select>
        <el-select
          v-model="resForm[item.prop]"
          :placeholder="$t(item.placeholder)"
          clearable
          v-if="item.prop == 'status'"
        >
          <el-option :label="$t(`common.normal`)" value="N"></el-option>
          <el-option :label="$t(`common.forbid`)" value="F"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="bottomBtns" :class="addClass">
      <el-button class="yesBtn" type="primary" @click="confirm()">{{
        $t(`common.confirm`)
      }}</el-button>
      <el-button class="noBtn" @click="setDrawer(false)">{{
        $t(`common.cancel`)
      }}</el-button>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: "LeftDrawer",
  props: {
    drawerTitle: {
      type: String,
      default: "",
    },
    showDrawer: {
      type: Boolean,
      default: false,
    },
    drawerMode: {
      type: String,
      default: "add",
    },
    type: {
      type: String,
      default: "",
    },
    formData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    addoreditForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
    treeData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    selectedItems: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      selectedUrl: [],
      resFormRules: {},
      defaultProps: {
        children: "children",
        label: "label",
      },
      api: {},
      tableType: "",
      tableData: {},
      resForm: {
        resCode: "",
        resName: "",
        resNameCn: "",
        resSequence: "",
        belongSys: "",
        resType: "",
        resParent: "",
        remark: "",
        status: "",
        resContent: "",
        resIcon: "",
        resIconType: "",
        moduleText: "",
        moduleImg: "",
        urlList: [],
      },
      true: true,
      false: false,
      addClass: "",
      formRules: {},
    };
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      let drawerHeight =
        document.getElementsByClassName("el-drawer__body")[0].scrollHeight;
      let screenHeight = window.screen.height;
      if (drawerHeight > screenHeight) {
        //按钮固定在抽屉下方
        this.addClass = "fixedBottom";
      } else {
        this.addClass = "";
      }
      this.$refs["resForm"].resetField();
    });
    let _this = this;
    this.formRules = Object.assign(
      {},
      (function () {
        let obj1 = {};
        _this.formData.forEach((item) => {
          let obj = {};
          obj[item.prop] = [
            {
              required: item.required,
              message: _this.$t(`common.pleaseInput`),
              trigger: "blur",
            },
          ];
          Object.assign(obj1, obj);
        });
        return obj1;
      })()
    );
    if (this.drawerMode == "edit") {
      //说明是编辑模式
      this.$set(this, "resForm", this.addoreditForm);
    } else {
      this.$set(this, "resForm", {});
    }
    console.log("this.selectedItems.length", this.selectedItems.length);
    if (this.selectedItems.length == 0) {
      this.resForm.resType = "MODULE"; //不选父元素的话只能添加模块
    }
  },
  computed: {
    buttonAuth: function () {
      return this.$store.getters.auth.buttonAuth;
    },
  },
  methods: {
    checkName(name) {
      //防止新增时名字重复
      let arr = this.resForm.urlList.filter((item) => {
        return item.name == name;
      });
      if (arr.length > 1) {
        this.$message({
          type: "warning",
          message: this.$t("common.onlyone") + "！",
        });
      }
    },
    checkValue(value) {
      //防止新增时值重复
    },
    getRowKey(row) {
      return row.index;
    },
    addUrl() {
      console.log("this.resForm", this.resForm);
      if (!this.resForm.urlList) {
        this.$set(this.resForm, "urlList", []);
      }
      let length = this.resForm.urlList.length;
      console.log("length", length);
      this.$nextTick(() => {
        this.resForm.urlList.push({ name: "", value: "" });
      });
    },
    deleteUrl() {
      this.resForm.urlList.splice(this.selectedUrl.index, 1);
    },
    delete() {},
    // clickInput(prop){
    //     console.log('prop',prop)
    // },
    callBackAction(param) {
      if (param.event !== "handleSelectionChange") {
        this[param.event](param);
      }
    },
    handleSelectionChange(val) {
      //选择待删除的url
      this.selectedUrl = val;
    },
    query() {
      // this.tableData = {
      //   data: [
      //     {
      //       ID: "23424234asea3",
      //       name: "王srs虎",
      //       email: "2423434@qq.com",
      //       job: "普通",
      //       status: "正常",
      //     },
      //     {
      //       ID: "234242343fcxv",
      //       name: "王sdf虎",
      //       email: "2423434@qq.com",
      //       job: "普通",
      //       status: "正常",
      //     },
      //   ],
      // };
    },
    addResourceGroup() {
      this.$emit("addResourceGroup");
    },
    add() {},
    remove(items) {
      this.$emit("deleteResourceGroup", items.selectedItems);
    },
    setDrawer(v) {
      this.$emit("changeDrawer", v);
    },
    confirm() {
      this.$refs["resForm"].validate((valid) => {
        if (valid) {
          this.$emit("addoredit", {
            form: this.resForm,
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bottomBtns {
  text-align: left;
  /* text-align: center;
  margin-left:-20px;
  width: 675px;
  height:60px;
  line-height:60px;
  background-color: white; */
}
.titleName {
  // font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #343c6a;
  // letter-spacing: 0;
  font-weight: 400;
}
.line {
  display: inline-block;
  height: 18px;
  width: 2px;
  background: #303133;
  margin-right: 5px;
}
.classTitle {
  height: 32px;
  line-height: 32px;
  font-size: 18px;
}
form {
  height: 100%;
  margin-bottom: 30px;
}
.addDrawerTitle {
  margin-bottom: 20px;
}
.fixedBottom {
  position: fixed;
  bottom: 0;
}
::v-deep .el-drawer__body {
  position: relative;
}
::v-deep .el-input__inner {
  background: #ffffff;
  border: 1px solid #dbdbdb;
  border-radius: 2px;
}
::v-deep .el-drawer__open .el-drawer.rtl {
  width: 660px !important;
}
::v-deep .el-drawer__open .el-form-item__content {
  width: 600px !important;
}
::v-deep .el-form-item__label {
  width: 100%;
  text-align: left;
}
.heightItem {
  height: 300px;
}
::v-deep .el-select {
  width: 600px !important;
}
</style>
